/** `current` es esa ruta, o cuelga de ella. Nunca "empieza con esas letras". */
function isUnder(current: string, route: string): boolean {
  return current === route || current.startsWith(route + "/");
}

export function isRouteActive(currentPath: string, itemPath: string): boolean {
  // Special case for home route
  if (itemPath === "/") {
    return currentPath === "/";
  }

  // Remove trailing slashes for consistent comparison
  const normalizedCurrent = currentPath.replace(/\/$/, "");
  const normalizedItem = itemPath.replace(/\/$/, "");

  // Exact match first
  if (normalizedCurrent === normalizedItem) {
    return true;
  }

  // Rutas que viven DEBAJO de la url de otra entrada del sidebar pero pertenecen
  // a otro grupo. Sin esta lista, el fallback de abajo (`startsWith`) prende las
  // dos: parado en /inventario/grupos se iluminaban a la vez "Productos" (que es
  // donde vive) e "Inventario" (que es prefijo suyo).
  //
  // ⚠️ SIGUE SIENDO UNA LISTA A MANO. Cada ruta nueva bajo /inventario que
  // cuelgue de otro grupo del sidebar hay que agregarla acá. Lo que ya NO hace
  // falta cuidar es el orden ni los prefijos que se pisan: la comparación es por
  // segmento y gana la coincidencia más larga (ver abajo).
  const moreSpecificRoutes = [
    "/inventario/productos",
    "/inventario/sueltos",
    "/inventario/categorias",
    "/inventario/locales",
    "/inventario/grupos",
    "/inventario/grupos-de-consumo",
    "/proveedores/marcas",
  ];

  // Gana la MÁS LARGA, y la comparación es por segmento.
  //
  // Las dos cosas hacen falta desde que existe `/inventario/grupos-de-consumo`:
  // con el `startsWith` pelado de antes, esa ruta "empezaba con"
  // `/inventario/grupos` y prendía Grupos de productos; y aun arreglando eso,
  // dos rutas anidadas de verdad (`/a` y `/a/b`) prendían las dos a la vez. Es
  // el arreglo de fondo que pedía el comentario de arriba.
  const matches = moreSpecificRoutes
    .filter((route) => isUnder(normalizedCurrent, route))
    .sort((a, b) => b.length - a.length);

  if (matches.length > 0) {
    return matches[0] === normalizedItem;
  }

  // Default behavior: match if current path starts with item path followed by / or end
  return isUnder(normalizedCurrent, normalizedItem);
}
